import { render } from "./aTable.vue?vue&type=template&id=55f5bff4"
import script from "./aTable.vue?vue&type=script&lang=js"
export * from "./aTable.vue?vue&type=script&lang=js"

import "./aTable.vue?vue&type=style&index=0&id=55f5bff4&lang=less"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__